export class ApiError extends Error {
  constructor(public status: number, message: string, public code?: string, public data: Record<string, any> = {}) {
    super(message);
  }
}

/** All requests are same-origin JSON with the custom CSRF header. A network failure becomes status 0 ("offline"). */
export async function api<T = any>(method: string, path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      credentials: "same-origin",
      headers: { "X-BB-Client": "1", ...(body !== undefined ? { "Content-Type": "application/json" } : {}) },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError(0, "Du ser ud til at være offline. Tjek din internetforbindelse og prøv igen.", "offline");
  }
  const text = await res.text();
  let data: any = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    /* non-JSON error page */
  }
  if (!res.ok) {
    const { error, code, ...rest } = data ?? {};
    throw new ApiError(res.status, error ?? "Noget gik galt. Prøv igen.", code, rest);
  }
  return data as T;
}
export const get = <T = any>(p: string) => api<T>("GET", p);
export const post = <T = any>(p: string, b: unknown = {}) => api<T>("POST", p, b);
export const patch = <T = any>(p: string, b: unknown = {}) => api<T>("PATCH", p, b);
export const del = <T = any>(p: string) => api<T>("DELETE", p);
